module.exports = __webpack_public_path__ + "static/img/CHEN_PEI-LING.png";